/* unplugin-vue-components disabled */import { render } from "./member_userCard_xq.vue?vue&type=template&id=322c73ca&scoped=true"
import script from "./member_userCard_xq.vue?vue&type=script&lang=js"
export * from "./member_userCard_xq.vue?vue&type=script&lang=js"

import "./member_userCard_xq.vue?vue&type=style&index=0&id=322c73ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-322c73ca"]])

export default __exports__